import { Button, Modal, Result } from 'antd';
import { useEffect, useState } from 'react';
import styled from 'styled-components';
import { useRefetchUser } from '../hooks/useRefetchUser';
import { useSchoolInvitesStore } from '../stores/SchoolInvitesStore';
import { trpc } from '../utils/trcp';

const Wrapper = styled.div<{ $hasPadding?: boolean }>`
	.ant-result {
		padding: 1em;
	}
`;

const UserUnusedInvites: React.FC = () => {
	const [isLoading, setIsLoading] = useState(false);
	// const [activeInvite, setActiveInvite] = useState<InviteType | undefined>(undefined);
	const [isModalVisible, setIsModalVisible] = useState(false);
	const getUnusedInvites = trpc.schoolInvite.getUnusedInvites.useQuery();
	const declineInvite = trpc.schoolInvite.declineInvite.useMutation();
	const applyInviteInAccount = trpc.schoolInvite.applyInviteInAccount.useMutation();
	const refetchUser = useRefetchUser();
	const invite = useSchoolInvitesStore(state => state.invite);
	const clearInvite = useSchoolInvitesStore(state => state.clearInvite);

	useEffect(() => {
		if (invite) {
			setTimeout(() => {
				setIsModalVisible(true);
			}, 100);
		}
	}, [invite]);

	const closeModal = () => {
		setIsModalVisible(false);
		setTimeout(() => {
			clearInvite();
		}, 100);
	};

	return (
		<Modal open={isModalVisible} footer={null} onCancel={closeModal}>
			<Wrapper>
				<Result
					icon={null}
					status="success"
					title={`Přijměte pozvánku do autoškoly ${invite?.schoolName}`}
					subTitle="V horní liště pak jednoduše přepínejte mezi autoškolami."
					extra={[
						<Button
							danger
							key="1"
							size="large"
							onClick={async () => {
								setIsLoading(true);
								await declineInvite.mutateAsync({ id: invite!.id });
								await getUnusedInvites.refetch();
								clearInvite();
								setIsLoading(false);
								setIsModalVisible(false);
							}}
							loading={isLoading}
						>
							Odmítnout pozvánku
						</Button>,
						<Button
							key="2"
							type="primary"
							size="large"
							loading={isLoading}
							onClick={async () => {
								setIsLoading(true);
								await applyInviteInAccount.mutateAsync({
									id: invite!.id,
								});

								refetchUser(() => {
									clearInvite();
									setIsLoading(false);
									setIsModalVisible(false);
								});
							}}
						>
							Přijmout pozvánku
						</Button>,
					]}
				/>
			</Wrapper>
		</Modal>
	);
};

export default UserUnusedInvites;
